import React from 'react';
import { withAnonymousUserLayout } from 'acscp/components/layout/anonymousUserLayout';
import { RouteComponentProps } from 'react-router-dom';
import { VerifyAccountForm } from '../auth/verifyAccountForm';

type VerifyAccountPageProps = RouteComponentProps<any>;

const VerifyAccountPagePresentational: React.SFC<VerifyAccountPageProps> = props => {
    const params = new URLSearchParams(props.location.search || undefined);
    const email = params.get('email') || undefined;
    const token = params.get('token') || undefined;
    const redirectTo = params.get('redirect') || undefined;
    return (<VerifyAccountForm email={email} token={token} successButtonDestination={redirectTo} />);
};

const VerifyAccountPage = withAnonymousUserLayout(VerifyAccountPagePresentational);

export { VerifyAccountPage };
